import { FaClock, FaEnvelope, FaFacebook, FaMapMarkerAlt, FaPhone, FaWhatsapp } from 'react-icons/fa';
import styled from 'styled-components';
import '../style/contact.css';

const Contact = () => {
  return (
    <ContactSection id="contact">
      <CoffeeBeansDecorTop />
      <ContactContainer>
        <SectionHeader>
          <SectionTitle>معلومات التواصل</SectionTitle>
          <Divider />
        </SectionHeader>

        <ContactGrid>
          <ContactCard>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <ContactContent>
              <ContactTitle>عنواننا</ContactTitle>
              <Location>
                <LocationName>Mnnnnn Cafe</LocationName>
                <Address>شارع الجامعة، المنطقة التجارية، مدينة القاهرة الجديدة</Address>
                <AddressNote>بجوار مركز التسوق الرئيسي</AddressNote>
              </Location>
            </ContactContent>
          </ContactCard>

          <ContactCard>
            <ContactIcon>
              <FaPhone />
            </ContactIcon>
            <ContactContent>
              <ContactTitle>اتصل بنا</ContactTitle>
              <PhoneNumber>
                <PhoneLabel>الاستفسارات العامة:</PhoneLabel>
                <PhoneLink >+20 111 222 3344</PhoneLink>
              </PhoneNumber>
              <PhoneNumber>
                <PhoneLabel>الطلبات السريعة:</PhoneLabel>
                <PhoneLink >+20 115 556 6677</PhoneLink>
              </PhoneNumber>
              <HoursNote>متاح خلال ساعات العمل</HoursNote>
            </ContactContent>
          </ContactCard>

          <ContactCard>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactContent>
              <ContactTitle>وسائل التواصل</ContactTitle>
              <div className="division">
                <a 
                  // href="https://wa.me/201112223344?text=مرحباً%20Moon%20Cafe%20،%20أريد%20الاستفسار%20عن%20..." 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="link-btn whatsapp"
                >
                  <FaWhatsapp /> واتساب للاستفسارات
                </a>
                <a 
                  // href="https://wa.me/201155566677?text=مرحباً%20،%20أريد%20طلب%20..." 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="link-btn whatsapp"
                >
                  <FaWhatsapp /> واتساب للطلبات
                </a>
                <a 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="link-btn facebook"
                >
                  <FaFacebook /> فيسبوك
                </a>          
              </div>
              <ResponseTime>نرد عادة خلال 15 دقائق</ResponseTime>
            </ContactContent>
          </ContactCard>

          <ContactCard>
            <ContactIcon>
              <FaClock />
            </ContactIcon>
            <ContactContent>
              <ContactTitle>ساعات العمل</ContactTitle>
              <HoursTable>
                <HoursRow>
                  <HoursDay>الأحد - الخميس:</HoursDay>
                  <HoursTime>8:00 ص - 12:00 ص</HoursTime>
                </HoursRow>
                <HoursRow>
                  <HoursDay>الجمعة والسبت:</HoursDay>
                  <HoursTime>9:00 ص - 1:00 ص</HoursTime>
                </HoursRow>
                <HoursRow>
                  <HoursDay>العطلات الرسمية:</HoursDay>
                  <HoursTime>10:00 ص - 11:00 م</HoursTime>
                </HoursRow>
              </HoursTable>
              <HoursNote>خدمة التوصيل متاحة حتى الساعة 11 مساءً</HoursNote>
            </ContactContent>
          </ContactCard>
        </ContactGrid>
      </ContactContainer>
      <CoffeeBeansDecorBottom />
    </ContactSection>
  );
};

// Styled Components
const ContactSection = styled.section`
  padding: 6rem 1rem;
  background-color: #f9f5f0;
  position: relative;
  overflow: hidden;
`;

const CoffeeBeansDecor = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  opacity: 0.03;
  z-index: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath fill='%23c57b57' d='M50,20c16.6,0,30,13.4,30,30s-13.4,30-30,30s-30-13.4-30-30S33.4,20,50,20z'/%3E%3C/svg%3E");
  background-repeat: repeat;
`;

const CoffeeBeansDecorTop = styled(CoffeeBeansDecor)`
  top: -50px;
  left: -50px;
  transform: rotate(15deg);
`;

const CoffeeBeansDecorBottom = styled(CoffeeBeansDecor)`
  bottom: -50px;
  right: -50px;
  transform: rotate(195deg);
`;

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.8rem;
  color: #2a1a1f;
  margin-bottom: 1rem;
  font-family: "Beiruti", sans-serif;
  font-weight: 700;
`;

const Divider = styled.div`
  width: 60px;
  height: 3px;
  background-color: #c57b57;
  margin: 1.5rem auto;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #c57b57;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
`;

const ContactCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
`;

const ContactIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #f0e6d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c57b57;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
`;

const ContactContent = styled.div`
  flex: 1;
`;

const ContactTitle = styled.h3`
  font-size: 1.8rem;
  color: #2a1a1f;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;
  font-family: "Beiruti", sans-serif;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background-color: #e3a27a;
  }
`;

const Location = styled.div`
  margin-bottom: 1.5rem;
`;

const LocationName = styled.h4`
  font-size: 1.4rem;
  color: #2a1a1f;
  margin-bottom: 0.5rem;
  font-family: "Beiruti", sans-serif;
`;

const Address = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  font-family: "Beiruti", sans-serif;
  font-size: 1.4rem;
`;

const AddressNote = styled.p`
  color: #999;
  font-size: 1.2rem;
  font-style: italic;
  margin-top: 0.5rem;
  font-family: "Beiruti", sans-serif;
`;

const PhoneNumber = styled.div`
  margin-bottom: 1rem;
  font-family: "Beiruti", sans-serif;
`;

const PhoneLabel = styled.span`
  display: block;
  font-size: 1.4rem;
  color: #666;
  margin-bottom: 0.2rem;
  font-family: "Beiruti", sans-serif;
`;

const PhoneLink = styled.a`
  color: #2a1a1f;
  font-size: 1.4rem;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s;
  font-family: "Beiruti", sans-serif;

  &:hover {
    color: #c57b57;
  }
`;

const HoursNote = styled.p`
  font-size: 1.4rem;
  color: #999;
  margin-top: 1rem;
  font-family: "Beiruti", sans-serif;
`;

const ResponseTime = styled.p`
  font-size: 1.4rem;
  color: #999;
  margin-top: 1rem;
  font-family: "Beiruti", sans-serif;
`;

const HoursTable = styled.div`
  width: 100%;
`;

const HoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px dashed #eee;
  align-items: center;
`;

const HoursDay = styled.span`
  color: #2a1a1f;
  font-size: 1.4rem;
  font-family: "Beiruti", sans-serif;
`;

const HoursTime = styled.span`
  color: #666;
  font-weight: 500;
  font-size: 1.4rem;
  font-family: "Beiruti", sans-serif;
`;

export default Contact;